// node_modules
import { FC, ChangeEvent, useEffect, useState } from "react";
// Controllers
import { CaseControllerSingleton } from "Controllers";
// Enums
import { CaseTagTypeEnum, ToastTypeEnum } from "Enums";
// Helpers
import { ToastHelperSingleton } from "Helpers";

// Const
const caseTagTypes: CaseTagTypeEnum[] = [
    CaseTagTypeEnum.None,
    CaseTagTypeEnum.Technology,
    CaseTagTypeEnum.Material,
    CaseTagTypeEnum.Component,
    CaseTagTypeEnum.Device,
    CaseTagTypeEnum.CoatingOrFilm,
    CaseTagTypeEnum.ProcessImprovement,
    CaseTagTypeEnum.Ingredient,
    CaseTagTypeEnum.ApplicationOrMarket,
    CaseTagTypeEnum.ProcessOrSystem,
    CaseTagTypeEnum.MethodOrFrameworkOrModel,
    CaseTagTypeEnum.Formula,
    CaseTagTypeEnum.Product
];

export type TCaseTagTypeProps = {
    caseId: number,
    caseTagType: CaseTagTypeEnum
};

export const CaseTagType: FC<TCaseTagTypeProps> = ({caseId, caseTagType}: TCaseTagTypeProps) => {
    // State
    const [tagType, setTagType] = useState<CaseTagTypeEnum>(CaseTagTypeEnum.None);

    // Logic
    useEffect(() => {
        // set component state
        setTagType(caseTagType);
    }, [caseTagType]);
    
    const updateCaseTagTypeAsync = async (changeEvent: ChangeEvent<HTMLSelectElement>): Promise<void> => {
        // safety-checks
        if (!changeEvent || 
                (changeEvent && !changeEvent.target) 
                || (changeEvent && changeEvent.target && !changeEvent.target.value)) { return; }
        
        // cast to enum number
        const newCaseTagType: number = parseInt(changeEvent.target.value, 10);

        // set component state
        setTagType(newCaseTagType);

        // call server to update case tag type
        const isSuccess = await CaseControllerSingleton.updateCaseTagTypeAsync(
            caseId,
            newCaseTagType
        );
        
        // tell user about update result 
        const newCaseTagTypeDisplayValue: string = getCaseTagTypeDisplayValue(newCaseTagType);
        if (!isSuccess) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, `Was not able to update case tag type to ${newCaseTagTypeDisplayValue}.`);
        } else {
            ToastHelperSingleton.showToast(ToastTypeEnum.Success, `Successfully updated case tag type to ${newCaseTagTypeDisplayValue}.`);
        }
        
        return;
    };

    const getCaseTagTypeDisplayValue = (caseTagType: number): string => {
        switch (caseTagType) {
            case CaseTagTypeEnum.CoatingOrFilm:
                return "Coating or film";
            case CaseTagTypeEnum.ProcessImprovement:
                return "Improvement of a process";
            case CaseTagTypeEnum.ApplicationOrMarket:
                return "Application or market";
            case CaseTagTypeEnum.ProcessOrSystem:
                return "Process or system";
            case CaseTagTypeEnum.MethodOrFrameworkOrModel:
                return "Method, framework or model";
            default:
                return CaseTagTypeEnum[caseTagType].toString();
        }
    };

    return (
        <div>
            <h4>Case type (for tagging)</h4>
            <select value={tagType} onChange={updateCaseTagTypeAsync}>
                {caseTagTypes.map((caseTagType: CaseTagTypeEnum)  => {
                    return (
                        <option key={caseTagType} value={caseTagType}>{getCaseTagTypeDisplayValue(caseTagType)}</option>
                    );
                })}
            </select>
        </div>
    );
};